import React from "react";
import { Check } from "lucide-react";

const INCLUDES = [
  "Exterior glass",
  "Window frames",
  "Exterior sills",
  "Tracks (deep-cleaned)",
  "Water-fed pole purified rinse",
  "Streak-free finish",
];

export default function DefaultService() {
  return (
    <section
      id="default-service"
      data-testid="default-service-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, #0B2542 0%, #0F4C81 60%, #114E89 100%)",
          }}
        />
        <div
          aria-hidden
          className="absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full opacity-40"
          style={{
            background:
              "radial-gradient(circle, rgba(0,180,216,0.6), rgba(0,180,216,0) 60%)",
          }}
        />
        <div
          aria-hidden
          className="absolute -bottom-40 -left-32 h-[520px] w-[520px] rounded-full opacity-30"
          style={{
            background:
              "radial-gradient(circle, rgba(144,224,239,0.5), rgba(144,224,239,0) 60%)",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 text-white">
          <span className="inline-block text-xs uppercase tracking-[0.22em] font-bold text-[#90E0EF]">
            Our standard package
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl lg:text-[58px] leading-[1.05] font-extrabold">
            Frames, sills, tracks & glass —{" "}
            <span className="text-[#90E0EF]">cleaned by default.</span>
          </h2>
          <p className="mt-5 text-lg text-white/80 max-w-2xl">
            Most companies charge extra for the details. We don't. Every booking
            includes our complete water-fed pole exterior service — frames, sills,
            tracks, and exterior glass — for a finish that's clean down to the last
            corner. Interior cleaning available as an add-on.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#quote"
              data-testid="default-service-cta"
              className="inline-flex items-center justify-center h-14 px-7 rounded-full bg-white text-[#0F4C81] font-semibold hover:bg-[#90E0EF] hover:text-[#0B2542] transition-colors"
            >
              Reserve your appointment
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center h-14 px-7 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition-colors"
              data-testid="default-service-secondary"
            >
              See full service list
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-3xl p-7 lg:p-8 vgc-glass-dark border border-white/10">
            <div className="text-sm uppercase tracking-[0.2em] text-[#90E0EF] font-bold mb-4">
              Always included
            </div>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-3">
              {INCLUDES.map((item, i) => (
                <li
                  key={item}
                  className="flex items-start gap-3 text-white/90"
                  data-testid={`include-${i}`}
                >
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-[#90E0EF] text-[#0B2542] flex items-center justify-center flex-shrink-0">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-[15px] leading-snug">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10 text-xs text-white/70">
              Need only specific surfaces? We'll customize — just ask.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
